import { Col, Row } from '@advanza/grid'
import { SelectSimple } from '@advanza/input'
import { Icon } from '@advanza/ui'
import { changeSubscriptionFilter } from 'actions/subscriptions'
import ServicesSelect from 'components/services/ServicesSelect'
import { useAppDispatch, useAppSelector } from 'hooks/hooks'
import React, { useEffect } from 'react'

function useGetSubscriptions(providerId) {
    const dispatch = useAppDispatch()
    const filterId = 'p_' + providerId
    useEffect(() => {
        dispatch(changeSubscriptionFilter(filterId, { providerIds: [providerId] }))
    }, [dispatch, filterId, providerId])
    const { entities, result, filters } = useAppSelector((state) => state.subscriptions)
    const filter = filters[filterId] || {}
    const pages = result[filter.searchKey] || {}
    const results = pages[0] || []
    const subscriptions = results.map((id) => (entities.subscriptions || {})[id]).filter(Boolean)
    const { questions = {}, services = {}, options = {} } = entities
    return {
        subscriptions,
        questions,
        services,
        options,
    }
}

const ServicePicker = ({ providerId, serviceId, optionId, changeEntity, hideOptions }) => {
    const { subscriptions, services, questions, options } = useGetSubscriptions(providerId)
    const serviceIds = subscriptions.map((subscription) => parseInt(subscription.service_id))
    const firstServiceId = serviceIds[0]
    const service = services[serviceId]
    const optionIds = (service?.questions ?? []).flatMap((id) => questions[id]?.options ?? [])
    useEffect(() => {
        if (!serviceId && firstServiceId) {
            changeEntity({ service_id: firstServiceId })
        }
    }, [serviceId, firstServiceId])
    return (
        <Row>
            <Col xs>
                <ServicesSelect
                    filter={(id) => serviceIds.includes(parseInt(id))}
                    value={serviceId}
                    multiple={false}
                    placeholder="Service"
                    onChangeValue={(services) =>
                        changeEntity({
                            service_id: services[0] ?? null,
                        })
                    }
                />
            </Col>
            {!hideOptions && (
                <Col xs>
                    <SelectSimple
                        onChange={(e) => {
                            const value = e.target.value
                            changeEntity({
                                option_id:
                                    value === '_hidden_' || value === ''
                                        ? null
                                        : parseInt(value, 10),
                            })
                        }}
                        value={optionId || '_hidden_'}
                        hiddenOption="All options"
                        placeholder="Option"
                        options={optionIds
                            .filter((id) => options[id])
                            .map((id) => {
                                return {
                                    value: id,
                                    name: options[id].value,
                                }
                            })}
                    />
                </Col>
            )}
            {optionId && (
                <Col x>
                    <button
                        onClick={(e) => {
                            changeEntity({ option_id: null })
                            e.preventDefault()
                            e.stopPropagation()
                        }}>
                        <Icon name="close" />
                    </button>
                </Col>
            )}
        </Row>
    )
}

export default ServicePicker
